import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthorizationInterceptor } from './interceptors';
import { AuthenticationService, ErrorService, LocalStorageService } from './services';
import localeDe from '@angular/common/locales/de';
import { LoggingService } from '@lib-ui/lib/services/logging.service';
import { RoleService } from '@lib-ui/lib/services/role.service';
import { APP_ENV, EnvironmentBase } from '@environments/environment.base';

registerLocaleData(localeDe);
const PROVIDERS = [
  { provide: ErrorHandler, useClass: ErrorService },
  LoggingService,
  AuthenticationService,
  LocalStorageService,
  RoleService,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthorizationInterceptor,
    multi: true,
  },
];

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class LibUiModule {
  public static forRoot(environment: Partial<EnvironmentBase>): ModuleWithProviders<LibUiModule> {
    return {
      ngModule: LibUiModule,
      providers: [
        ...PROVIDERS,
        {
          provide: APP_ENV,
          useFactory: () => environment,
        },
      ],
    };
  }
}
